import history from 'services/history';
import { getEmailsService, updateEmailService } from 'services/email';

export const setLoading = (dispatch, value) => {
  dispatch({
    type: 'SET_LOADING',
    payload: value,
  });
};

const mapPriorityStatus = (priority: number) => {
  switch (priority) {
    case 0:
      return undefined;
    case 1:
      return false;
    case 2:
      return true;
    default:
      true;
  }
};

export const getEmails = async (
  dispatch,
  page,
  search,
  filter,
  clouds,
  order,
  ctrl,
) => {
  setLoading(dispatch, true);
  try {
    const { data } = await getEmailsService(
      {
        ...search,
        page,
        filter,
        clouds,
        [`${order?.column}_order`]: mapPriorityStatus(order?.value),
      },
      ctrl,
    );

    dispatch({
      type: 'GET_EMAILS',
      payload: data,
    });
    setLoading(dispatch, false);
  } catch (e) {
    if (e.message !== 'canceled') setLoading(dispatch, false);
    if (e?.response?.status === 404) {
      history.push('/404');
    }
  }
};

export const updateEmail = async (dispatch, field, value, id) => {
  try {
    const { data } = await updateEmailService(id, {
      [field]: value,
    });

    dispatch({
      type: 'UPDATE_EMAIL',
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: 'UPDATE_EMAIL_ERROR',
      payload: e?.response?.data,
    });
  }
};
